import { createAction, createAsyncAction } from 'typesafe-actions'
import { ModelRecommendationsData } from '../../../entities/ModelRecommendationsData'
import { RecommendationsData } from '../../../entities/RecommendationsData'
import { RecommendationsTrackingData } from '../../../entities/RecommendationsTrackingData'

export const fetchVwnModelsWithRecommendations = createAction('CMD / VwnRecommendationsData / fetch')()

export const fetchVwnRecommendationsForModel = createAction('CMD / VwnModelRecommendationsData / fetch')()

export const fetchVwnModelsWithRecommendationsAsync = createAsyncAction(
    'EVT / VwnRecommendationsData / fetch request',
    'EVT / VwnRecommendationsData / fetch success',
    'EVT / VwnRecommendationsData / fetch failure',
)<undefined, RecommendationsData, Error>()

export const trackVwnRecommendedEquipmentsAsync = createAsyncAction(
    'EVT / VwnRecommendationsTrackingData / fetch request',
    'EVT / VwnRecommendationsTrackingData / fetch success',
    'EVT / VwnRecommendationsTrackingData / fetch failure',
)<void, void, Error>()

export const fetchVwnRecommendationsForModelAsync = createAsyncAction(
    'EVT / VwnModelRecommendationsData / fetch request',
    'EVT / VwnModelRecommendationsData / fetch success',
    'EVT / VwnModelRecommendationsData / fetch failure',
)<undefined, ModelRecommendationsData, Error>()

export const setVwnModelsWithRecommendationsData = createAction('DOC / VwnRecommendationsData / set state')<RecommendationsData>()

export const setVwnRecommendationsForModelData = createAction('DOC / VwnModelRecommendationsData / set state')<ModelRecommendationsData>()

export const trackVwnRecommendedEquipments = createAction('DOC / VwnRecommendationsTrackingData / track equipments')<RecommendationsTrackingData>()

export const resetVwnRecommendationsForModelData = createAction('DOC / VwnModelRecommendationsData / reset state')()

export const resetVwnModelsWithRecommendationsData  = createAction('DOC / VwnRecommendationsData / reset state')()
